exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1spdAvA1tZhAWWH-TndqHa{padding-top:10px;display:flex;flex-flow:column}._1QQ34ahUTQhL3duGHmvMMM{padding:10px 20px}.qVeQSc1GctgeedLm1HzwI{padding:10px 20px;display:flex;justify-content:space-between}.qVeQSc1GctgeedLm1HzwI h3{margin-bottom:5px}.qVeQSc1GctgeedLm1HzwI._3XlWv3wsjoJy1DAZgU773w{background:#f5f5f5}._3-XMDDurJyxsjYZotb85yv{color:#757575}._1ewn8H9ixr_PzmpHwOYeMi{color:#757575;display:flex}.LCiHQ3rd4IPaKJRcjBYqN{display:none;margin-left:30px;width:50px;justify-content:space-between;color:#616161}.LCiHQ3rd4IPaKJRcjBYqN._3XlWv3wsjoJy1DAZgU773w{display:flex}.LCiHQ3rd4IPaKJRcjBYqN span{cursor:pointer}._3S3dJp-dCds7JTnYmwCXZy{display:flex;margin:20px}\n", ""]);

// Exports
exports.locals = {
	"cardBody": "_1spdAvA1tZhAWWH-TndqHa",
	"empty": "_1QQ34ahUTQhL3duGHmvMMM",
	"milestoneRow": "qVeQSc1GctgeedLm1HzwI",
	"hovered": "_3XlWv3wsjoJy1DAZgU773w",
	"overview": "_3-XMDDurJyxsjYZotb85yv",
	"completed": "_1ewn8H9ixr_PzmpHwOYeMi",
	"actions": "LCiHQ3rd4IPaKJRcjBYqN",
	"milestoneCTA": "_3S3dJp-dCds7JTnYmwCXZy"
};